const standardCardStrings = {
  tag: {
    title: 'New',
  },
};

export default standardCardStrings;
